import { useMutation } from "react-query";
import { createDevPayment } from "./gateway";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/useAuth";

export default function useCreateDevPaymentMutation() {
  const navigate = useNavigate();
  const { userHomePath } = useAuth();
  return useMutation({
    mutationFn: createDevPayment,
    mutationKey: "createDevPayment",
    onSuccess: () => {
      navigate(userHomePath);
    },
  });
}
